import React from 'react'
import styled from '@emotion/styled'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'
import Link from 'next/link'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { getAbstract } from 'components/vendor/Contentful/richText/utils'

interface PartnerModel {
	partner: Partner
}

export const PartnerItem = ({ partner }: PartnerModel): JSX.Element => {
	const partnerText = partner.description ? getAbstract(partner.description) : partner.name

	return (
		<Link href={partner.relativePath} legacyBehavior>
			<PartnerItemWrapper>
				<PartnerImage>
					<ContentfulImage layout={'fixed'} width={120} quality={40} asset={partner.logo} />
				</PartnerImage>
				<PartnerText>{partnerText}</PartnerText>
			</PartnerItemWrapper>
		</Link>
	)
}

const PartnerItemWrapper = styled.div`
	display: flex;
	padding: 24px;
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: ${COLORS.WHITE};
	align-items: center;
	transition: 0.3s;
	&:hover {
		transform: translateY(-5px);
	}
	height: 120px;
	cursor: pointer;

	@media only screen and (${PAGE_BREAKPOINTS.DESKTOP_MEDIUM}) {
		flex-direction: column;
		height: 100%;
		justify-content: center;
	}

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 282px;
	}
`

const PartnerImage = styled.div`
	min-width: 140px;
	max-height: 38px;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	@media only screen and (${PAGE_BREAKPOINTS.DESKTOP_MEDIUM}) {
		margin-right: 0;
		margin-bottom: 16px;
		justify-content: center;
		min-width: unset;
		max-height: unset;
	}
`

const PartnerText = styled.p`
	max-height: calc(3 * 1.5em);
	line-height: 1.5;
	-webkit-line-clamp: 3;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	display: -webkit-box;
	word-break: break-word;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		max-height: calc(6 * 1.5em);
		-webkit-line-clamp: 6;
		text-align: center;
	}
`
